import { render, staticRenderFns } from "./CustomersList.vue?vue&type=template&id=16f1fde1&scoped=true&"
import script from "./CustomersList.vue?vue&type=script&lang=js&"
export * from "./CustomersList.vue?vue&type=script&lang=js&"
import style0 from "./CustomersList.vue?vue&type=style&index=0&id=16f1fde1&lang=scss&scoped=true&"
import style1 from "./CustomersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f1fde1",
  null
  
)

export default component.exports